/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 8/20/20
 * Time: 4:22 PM
 */
import React, {Component} from 'react';
import './PaymentAuthorize.scss';
import '../../../components/Loader/Loader.scss';
import * as constants from "../../../const/constants";
import * as classService from "../../../services/class";
import * as lessonService from "../../../services/lessons";
import * as courseService from "../../../services/courses";
import * as commonFunc from "../../../utils/commonFunc";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import Cookies from "js-cookie";
import swal from "sweetalert";
import {lang, language} from "../../../const/language";

class App extends Component {

    state = {
        isLoading: true,
    }

    async componentDidMount() {

        let location = window.location.href;
        if (location.indexOf("trId=") !== -1 && location.indexOf("merchantRID=") !== -1) {
            let transactionId = location.split("trId=")[1].split("&")[0];
            let merchantRID = location.split("merchantRID=")[1].split("&")[0];

            const obj = {
                "transactionId": transactionId,
                "merchantRID": merchantRID
            };

            const payment = Cookies.get(constants.PAYMENT_TYPE);

            let service = classService;
            if (payment === 'lesson') {
                service = lessonService;
            } else if (payment === 'course') {
                service = courseService;
            }
            console.log(payment);
            await service.enrollClassPayment(obj)
                .then(response => {
                    commonFunc.notifyMessage(response.message, response.status);
                    if (response.success) {
                        this.resultPage("SUCCESS", payment, response);
                    } else {
                        this.resultPage("ERROR", payment, response);
                    }
                })

        } else {
            // commonFunc.notifyMessage("Payment", 0);
            this.resultPage("ERROR", null, null);
        }
    }

    resultPage = (status, payment, response = null) => {
        console.log("status: ", status);
        console.log("payment: ", payment);
        console.log("response: ", response);

        if (status === "SUCCESS") {
            this.setState({
                isLoading: false,
            }, () => {
                swal({
                    title: response && response.message ? response.message : "Course card payment completed successfully",
                    icon: null,
                    closeOnClickOutside: false,
                    buttons: {
                        dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                    },
                }).then((value) => {
                    switch (value) {
                        case "action":
                            if (payment === 'class') {
                                this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_CLASS_ROUTE}`);
                            }
                            if (payment === 'course') {
                                this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_COURSE_ROUTE}`);
                            } else {
                                this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_LESSONS_ROUTE}`);
                            }
                            break;
                        default:
                            break;
                    }
                });
            })

            // if (payment === 'class') {
            //     this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_CLASS_ROUTE}`);
            // }
            // if (payment === 'course') {
            //     this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_COURSE_ROUTE}`);
            // } else {
            //     this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_LESSONS_ROUTE}`);
            // }
        }

        if (status === "ERROR") {
            this.setState({
                isLoading: false,
            }, () => {
                swal({
                    title: response && response.message ? response.message : "Error occurred!",
                    icon: null,
                    closeOnClickOutside: false,
                    buttons: {
                        dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                    },
                }).then((value) => {
                    switch (value) {
                        case "action":
                            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`);
                            break;
                        default:
                            break;
                    }
                });
            })
        }
    };

    // resultPage = (status, payment) => {
    //     console.log(status, payment);
    //
    //     if (status === "SUCCESS") {
    //
    //         if (payment === 'class') {
    //             this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_CLASS_ROUTE}`);
    //         }
    //         if (payment === 'course') {
    //             this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_COURSE_ROUTE}`);
    //         } else {
    //             this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_LESSONS_ROUTE}`);
    //         }
    //     }
    //     if (status === "ERROR") {
    //         this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`);
    //     }
    // };

    render() {
        return (
            <div className={"payment-authorize"}>
                <div className={"main"}>


                    {
                        this.state.isLoading && (
                            <div className={"loader-teach-css"}>
                                <div className={"loader-wrapper"}>
                                    <div className={"loader-main"}>

                                        <div className={"f-f mr-1"}>
                                            Authorising, please wait
                                        </div>
                                        <div className="loader"/>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isPaymentObj: state.modal.isPaymentObj,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
